module.exports = __webpack_public_path__ + "static/media/previewImageBackground.efe0c255.png";